(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6654],{

/***/ 50046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductWithRequiredModifiers; }
/* harmony export */ });
function ProductWithRequiredModifiers(product) {
    if (!product.modifiers) return null;
    return !!product.modifiers.find(function(modifier) {
        return !modifier.optional;
    });
};


/***/ }),

/***/ 13336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SelectPriceForProduct; }
/* harmony export */ });
function SelectPriceForProduct(product) {
    var availabilityAt = product.availabilityAt, promotions = product.promotions;
    if (!availabilityAt) return null;
    var hasDiscount = availabilityAt.hasDiscount, finalPrice = availabilityAt.finalPrice, basePrice = availabilityAt.basePrice, available = availabilityAt.available, notAvailableMessage = availabilityAt.notAvailableMessage;
    if (!available) return {
        type: "notAvailable",
        message: notAvailableMessage
    };
    if (hasDiscount) return {
        type: "discount",
        price: finalPrice,
        oldPrice: basePrice
    };
    if (promotions === null || promotions === void 0 ? void 0 : promotions.length) return {
        type: "promotions",
        price: finalPrice,
        promotionType: promotions[0].promotionType
    };
    if (!finalPrice) return null;
    return {
        type: "normal",
        price: finalPrice
    };
};


/***/ }),

/***/ 19279:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var PRICING_TYPES;
(function(PRICING_TYPES) {
    PRICING_TYPES["normal"] = "normal";
    PRICING_TYPES["discount"] = "discount";
    PRICING_TYPES["promotions"] = "promotions";
    PRICING_TYPES["notAvailable"] = "notAvailable";
})(PRICING_TYPES || (PRICING_TYPES = {}));
/* harmony default export */ __webpack_exports__["Z"] = (PRICING_TYPES);


/***/ }),

/***/ 76722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56036);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32533);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68176);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);



// import useBlurhash from '@hooks/useBlurhash'



function ImageComponent(props) {
    var product = props.product;
    var image = product.images ? product.images[0] : null;
    // const blurhash = useBlurhash(image?.colors?.blurhash4x4, 166, 166)
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("website", {
        keyPrefix: "order.products.productsContent.category.product.image"
    }).t;
    if (!product.images || !product.images.length) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().noImage),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().noImageText),
                children: t("labelNoImage")
            })
        });
    }
    var productImg = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: image.imageSmall,
            alt: product.altImg || product.name,
            title: product.titleImg || product.name,
            layout: "fill",
            objectFit: "contain"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().image), " ").concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default()["img-fit-container"])),
        children: [
            productImg(),
            product.images.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().hasMultipleImages),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdPhotoLibrary */ .C0e, {
                    size: 18
                })
            })
        ]
    });
};


/***/ }),

/***/ 46654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Category_Product; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/fireEvent.js
var fireEvent = __webpack_require__(93415);
// EXTERNAL MODULE: ./src/data/fragments/products/productListInformation.main.ts
var productListInformation_main = __webpack_require__(2779);
// EXTERNAL MODULE: ./src/helpers/analytics/events/index.ts + 3 modules
var events = __webpack_require__(54646);
// EXTERNAL MODULE: ./src/helpers/analytics/sendEvents.ts
var sendEvents = __webpack_require__(76110);
// EXTERNAL MODULE: ./src/hooks/useAnalyticLocation.ts
var useAnalyticLocation = __webpack_require__(78425);
;// CONCATENATED MODULE: ./src/helpers/misc/queryObjectToString.ts
var hiddenKeys = [
    "hostname",
    "mobileOrDesktop"
];
function queryObjectToString(query) {
    return Object.keys(query).filter(function(key) {
        return !hiddenKeys.includes(key);
    }).map(function(key) {
        return "".concat(key, "=").concat(query[key]);
    }).join("&");
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/slugify/slugify.js
var slugify = __webpack_require__(31304);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ./src/hooks/useIsSpecialLayout.ts
var useIsSpecialLayout = __webpack_require__(5455);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
;// CONCATENATED MODULE: ./src/hooks/useProductLink.tsx





function useProductLink(product) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var layout = (0,useIsSpecialLayout/* default */.Z)();
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var router = (0,next_router.useRouter)();
    if (opts.skipRedirection) return "#";
    var query = queryObjectToString(router.query);
    var queryStr = query ? "?".concat(query) : "";
    var slug = slugify_default()(product.name, {
        lower: true,
        strict: true
    });
    if (layout === "chat") {
        return "/chat/".concat(websiteId, "/order/").concat(product._id, "/").concat(slug).concat(queryStr);
    }
    return "/pedir/".concat(product._id, "/").concat(slug).concat(queryStr);
};

// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(40076);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/index.tsx + 1 modules
var DeliveryWizard = __webpack_require__(16312);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/usePreferencesForAddressContext.main.ts
var usePreferencesForAddressContext_main = __webpack_require__(38417);
// EXTERNAL MODULE: ./src/helpers/misc/productWithRequiredModifiers.ts
var productWithRequiredModifiers = __webpack_require__(50046);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/index.tsx + 2 modules
var useAdd = __webpack_require__(80885);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/InformativeStamps/index.tsx + 1 modules
var InformativeStamps = __webpack_require__(79989);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Cards/RowProduct/styles.module.css
var styles_module = __webpack_require__(43908);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Cards/RowProduct/ProductDescription.tsx





function ProductDescription(props) {
    var ref;
    var product = props.product, description = props.description, onClick = props.onClick, hidePrice = props.hidePrice, href = props.href;
    var informativeStampsList = product === null || product === void 0 ? void 0 : (ref = product.informativeStamps) === null || ref === void 0 ? void 0 : ref.slice(0, 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).content,
        children: hidePrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).name,
                    children: product.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InformativeStamps/* default */.Z, {
                    stamps: informativeStampsList,
                    iconOnly: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).description,
                    children: description
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            prefetch: false,
            scroll: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).name,
                        children: product.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InformativeStamps/* default */.Z, {
                        stamps: informativeStampsList,
                        iconOnly: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).description,
                        children: description
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Cards/RowProduct/ProductImage.tsx




function ProductImage(props) {
    var images = props.images, hidePrice = props.hidePrice, onClick = props.onClick, image = props.image, href = props.href;
    if (!(images === null || images === void 0 ? void 0 : images.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).image,
        children: hidePrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            onClick: onClick,
            children: image
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            prefetch: false,
            scroll: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                onClick: onClick,
                children: image
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/PromotionTag/index.tsx
var PromotionTag = __webpack_require__(73002);
// EXTERNAL MODULE: ./src/helpers/misc/selectPriceForProduct.ts
var selectPriceForProduct = __webpack_require__(13336);
// EXTERNAL MODULE: ./src/i18n/formatNumber/Component.tsx
var Component = __webpack_require__(18085);
// EXTERNAL MODULE: ./src/page-components/Order/CategoryPage/Content/Products/ProductCard/pricingTypes.tsx
var pricingTypes = __webpack_require__(19279);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Cards/RowProduct/ProductPrice.tsx








function ProductPrice(props) {
    var product = props.product, onClick = props.onClick, hidePrice = props.hidePrice, href = props.href;
    var pricing = (0,selectPriceForProduct/* default */.Z)(product);
    return pricing && !hidePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            prefetch: false,
            scroll: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: (styles_module_default()).price,
                onClick: onClick,
                children: [
                    pricing.type === pricingTypes/* default.normal */.Z.normal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                        value: pricing.price
                    }),
                    pricing.type === pricingTypes/* default.discount */.Z.discount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                value: pricing.price
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                    value: pricing.oldPrice
                                })
                            })
                        ]
                    }),
                    pricing.type === pricingTypes/* default.promotions */.Z.promotions && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionTag/* default */.Z, {
                        product: product
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Cards/RowProduct/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}















function RowProduct(props) {
    var router = (0,next_router.useRouter)();
    var preferences = (0,usePreferencesForAddressContext_main/* default */.Z)().preferences;
    var ref = (0,react.useState)(false), isAddressModalOpen = ref[0], setIsAddressModalOpen = ref[1];
    var product = props.product, onClick = props.onClick, menuId = props.menuId, _fastAddToCart = props.fastAddToCart, fastAddToCart = _fastAddToCart === void 0 ? false : _fastAddToCart, hidePrice = props.hidePrice, reverse = props.reverse, href = props.href;
    var isOutOfStock = product.isOutOfStock, images = product.images, availabilityAt = product.availabilityAt;
    var add = (0,useAdd/* default */.Z)();
    var requiredModifiers = (0,productWithRequiredModifiers/* default */.Z)(product);
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.products.productsContent.category.product.cards.rowProduct"
    }).t;
    var OutOfStockOrAvailable = isOutOfStock ? "labelOutOfStock" : "labelAddProduct";
    var notAvailableString = function() {
        var maxLength = 36;
        if (availabilityAt.notAvailableMessage.length > maxLength) {
            return "".concat(availabilityAt.notAvailableMessage.substring(0, maxLength), "...");
        }
        return availabilityAt.notAvailableMessage;
    };
    var unAvailableMessage = (availabilityAt === null || availabilityAt === void 0 ? void 0 : availabilityAt.notAvailableMessage) ? notAvailableString() : t("labelUnavailable");
    var handleButtonClick = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!hidePrice) {
                            _ctx.next = 3;
                            break;
                        }
                        (0,fireEvent["default"])("hiddenPriceProductOpened", product);
                        return _ctx.abrupt("return", null);
                    case 3:
                        if (!isOutOfStock) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", null);
                    case 5:
                        if (!(requiredModifiers || !fastAddToCart)) {
                            _ctx.next = 9;
                            break;
                        }
                        {
                            onClick();
                            router.push(href, href, {
                                scroll: false
                            });
                        }
                        _ctx.next = 14;
                        break;
                    case 9:
                        if (preferences === null || preferences === void 0 ? void 0 : preferences.storeId) {
                            _ctx.next = 12;
                            break;
                        }
                        setIsAddressModalOpen(true);
                        return _ctx.abrupt("return");
                    case 12:
                        _ctx.next = 14;
                        return add(_objectSpread({}, props, {
                            close: function() {
                            // avoid error on add to cart
                            },
                            menuId: menuId
                        }), {
                            amount: 1,
                            modifiers: [],
                            comment: ""
                        }, product, {
                            missingModifier: false
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((styles_module_default()).container, " ").concat(isOutOfStock || !(availabilityAt === null || availabilityAt === void 0 ? void 0 : availabilityAt.available) ? (styles_module_default()).containerOutOfStock : null, " ").concat(reverse ? (styles_module_default()).reverse : null),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, _objectSpread({
                images: images
            }, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).contentContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription, _objectSpread({}, props)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).priceContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice, _objectSpread({}, props)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                primary: true,
                                onClick: handleButtonClick,
                                disabled: isOutOfStock || !(availabilityAt === null || availabilityAt === void 0 ? void 0 : availabilityAt.available),
                                children: !(availabilityAt === null || availabilityAt === void 0 ? void 0 : availabilityAt.available) ? unAvailableMessage : t(OutOfStockOrAvailable)
                            })
                        ]
                    })
                ]
            }),
            isAddressModalOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryWizard/* default.AsModal */.Z.AsModal, {
                isOpen: isAddressModalOpen,
                onClose: function() {
                    setIsAddressModalOpen(false);
                },
                actionLocation: "quick-add-product"
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Image/index.tsx
var Image = __webpack_require__(76722);
// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/styles.module.css
var Product_styles_module = __webpack_require__(68176);
var Product_styles_module_default = /*#__PURE__*/__webpack_require__.n(Product_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Price/index.tsx






var renderPriceWithDiscounts = function(props) {
    if (props.hidePrice) return null;
    var _availabilityAt = props.product.availabilityAt, finalPrice = _availabilityAt.finalPrice, basePrice = _availabilityAt.basePrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Product_styles_module_default()).pastPrice,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                    value: basePrice
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Product_styles_module_default()).price,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                    value: finalPrice
                })
            })
        ]
    });
};
function Price(props) {
    var product = props.product;
    var availabilityAt = product.availabilityAt, promotions = product.promotions;
    var website = (0,useInitialData/* default */.Z)().website;
    var priceStyles = website.layout === "tiramisu" ? (Product_styles_module_default()).tiramisuPrice : (Product_styles_module_default()).price;
    if (!availabilityAt || props.hidePrice || !availabilityAt.finalPrice) return null;
    var hasDiscount = availabilityAt.hasDiscount, finalPrice = availabilityAt.finalPrice, available = availabilityAt.available, notAvailableMessage = availabilityAt.notAvailableMessage;
    if (!available) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Product_styles_module_default()).notAvailable,
        children: notAvailableMessage
    });
    if (hasDiscount) return renderPriceWithDiscounts(props);
    if (promotions === null || promotions === void 0 ? void 0 : promotions.length) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionTag/* default */.Z, {
            product: product
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: priceStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
            value: finalPrice
        })
    });
};

// EXTERNAL MODULE: ./src/components/Image/index.tsx
var components_Image = __webpack_require__(56036);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Info/TiramisuBtn/index.tsx




function TiramisuBtn(param) {
    var product = param.product, hidePrice = param.hidePrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-start items-center w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* default */.Z, {
                    src: "/images/tiramisu/shopping-basket.svg",
                    alt: "shopping basket",
                    width: "40px",
                    height: "40px"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center items-center font-bold text-vibrant-red text-xl px-2.5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                        product: product,
                        hidePrice: hidePrice
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Info/index.tsx






function Info(props) {
    var ref;
    var product = props.product, hidePrice = props.hidePrice;
    var description = product.description ? product.description.split("\n\n")[0] : "";
    var informativeStampsList = product === null || product === void 0 ? void 0 : (ref = product.informativeStamps) === null || ref === void 0 ? void 0 : ref.slice(0, 3);
    var website = (0,useInitialData/* default */.Z)().website;
    var tiramisuLayout = website.layout === "tiramisu";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Product_styles_module_default()).info,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Product_styles_module_default()).nameAndDescription,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Product_styles_module_default()).name,
                    children: product.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InformativeStamps/* default */.Z, {
                        stamps: informativeStampsList,
                        iconOnly: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Product_styles_module_default()).nameAndDescription,
                        children: props.productsLayout === "compact" ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (Product_styles_module_default()).description,
                                    children: description
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Product_styles_module_default()).space
            }),
            tiramisuLayout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TiramisuBtn, {
                product: product,
                hidePrice: hidePrice
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                product: product,
                hidePrice: hidePrice
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/UnavailableOrOutOfStock/index.tsx



function UnavailableOrOutOfStock(props) {
    var t = (0,esm/* useTranslation */.$G)("generic", {
        keyPrefix: "fields"
    }).t;
    var _product = props.product, isOutOfStock = _product.isOutOfStock, availabilityAt = _product.availabilityAt;
    var notAvailableMessage = (availabilityAt !== null && availabilityAt !== void 0 ? availabilityAt : {}).notAvailableMessage;
    if ((availabilityAt === null || availabilityAt === void 0 ? void 0 : availabilityAt.available) === true && !isOutOfStock || notAvailableMessage) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Product_styles_module_default()).outOfStock,
        children: t(isOutOfStock ? "outOfStock" : "notAvailable")
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Layout/index.tsx
function Layout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Layout_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Layout_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function Layout(props) {
    var href = props.href, productsLayout = props.productsLayout, image = props.image, parentProps = props.parentProps, className = props.className, onClick = props.onClick;
    return productsLayout === "compact" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        scroll: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: className.join(" "),
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnavailableOrOutOfStock, {
                    product: parentProps.product
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Product_styles_module_default()).img,
                    children: image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, Layout_objectSpread({}, parentProps))
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        scroll: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: className.join(" "),
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnavailableOrOutOfStock, {
                    product: parentProps.product
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, Layout_objectSpread({}, parentProps)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Product_styles_module_default()).img,
                    children: image
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/index.tsx
function Product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Product_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Product_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Product_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Product_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


/* eslint-disable @typescript-eslint/ban-types */ 










function Product(props) {
    var product = props.product, productCardDesign = props.productCardDesign, hidePrice1 = props.hidePrice, menuId1 = props.menuId, skipRedirection = props.skipRedirection;
    var isOutOfStock = product.isOutOfStock, availabilityAt = product.availabilityAt;
    var description = product.description ? product.description.split("\n\n")[0] : "";
    var productLink = useProductLink(product, {
        skipRedirection: skipRedirection
    });
    var actionLocation = (0,useAnalyticLocation/* default */.Z)("browse");
    var onClick = function() {
        var _ref = Product_asyncToGenerator(runtime_default().mark(function _callee() {
            var hidePrice, menuId, categoryId, categoryName, eventBaseProperties, select;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        hidePrice = props.hidePrice, menuId = props.menuId, categoryId = props.categoryId, categoryName = props.categoryName, eventBaseProperties = props.eventBaseProperties, select = props.select;
                        if (!hidePrice) {
                            _ctx.next = 4;
                            break;
                        }
                        (0,fireEvent["default"])("hiddenPriceProductOpened", product);
                        return _ctx.abrupt("return");
                    case 4:
                        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.browse.productSelected */.F.browse.productSelected, Product_objectSpread({
                            categoryId: categoryId,
                            categoryName: categoryName,
                            menuId: menuId,
                            productName: product.name,
                            actionLocation: actionLocation,
                            productId: product._id
                        }, eventBaseProperties));
                        if (select) {
                            select();
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var className = [
        props.productsLayout === "compact" ? (Product_styles_module_default()).compact : (Product_styles_module_default()).container
    ];
    if (isOutOfStock || !(availabilityAt === null || availabilityAt === void 0 ? void 0 : availabilityAt.available) && !(availabilityAt === null || availabilityAt === void 0 ? void 0 : availabilityAt.notAvailableMessage)) {
        className.push((Product_styles_module_default()).isOutOfStock);
    }
    var image = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        product: product
    });
    var isRow = [
        "row",
        "row-inverse",
        "row-inverse-fast",
        "row-fast",
        "row-inverse-fast"
    ].includes(productCardDesign);
    if (isRow) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RowProduct, {
            image: image,
            onClick: onClick,
            href: productLink,
            product: product,
            description: description,
            menuId: menuId1,
            reverse: [
                "row-inverse",
                "row-inverse-fast"
            ].includes(productCardDesign),
            fastAddToCart: [
                "row-fast",
                "row-inverse-fast"
            ].includes(productCardDesign),
            hidePrice: hidePrice1
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        href: productLink,
        productsLayout: props.productsLayout,
        image: image,
        parentProps: props,
        className: className,
        onClick: onClick
    });
}
Product.fragment = productListInformation_main/* default */.Z;
/* harmony default export */ var Category_Product = (Product);


/***/ }),

/***/ 43908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"kFAM9r3iQIG0byfT-0DRZ","containerOutOfStock":"_2hcu182p6ge0Ha_zWShSpI","contentContainer":"_178a98bcvBST7K_atUmI91","priceContainer":"_26aJkBHQbAhuvPTrmY-uBl","name":"_160B6gJP3LdIZUn0nc7sQK","description":"_7VMOZBkB065tRJNiM2wV","price":"_1u1utewmgUI9TW1dUfJP2m","callToAction":"_3jqIM86WHEywDUKRiZ5eOn","isOutOfStock":"_2poKx8sEXiLjr0583tkSaG","image":"_2_Q-vJD5-jRaD3i902Eoyl","reverse":"LXQDjkS_dqmYkoosRPgdQ"};

/***/ }),

/***/ 68176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_22r-bWq7SpQfhu-O7I0ecS buttonShadow menuProductItem textColor","compact":"_2YFsL04WhRxFGT_7VA6bKP buttonShadowHover compactMenuProductItem textColor","isOutOfStock":"CAboaQmRewA78h4-Z4y0_","info":"_3TOwV3RZUG4Ujx57ozcCHZ lighterBackgroundColor","outOfStock":"_5Gc5vjC_XjaLiwIP3_2Il","nameAndDescription":"_2Wn_Ubr02VMh4x3GDzmf1V","name":"_3tOb1kUYtBNfge7JfPDU_D productName","description":"_3B6c_WpWHEkHzgTsj5biDu productDescription descriptionTextColor","space":"vnnpMijtMXu9fU1y3lcEA","image":"_3yULoLW9gpjndljUfLfWLN","noImage":"_1nCMv7Afx2Xj5MC16tl54I","noImageText":"_2pHRf_Y-N8tKQL191aSJKr","hasMultipleImages":"_1on_s_PLo5gXsNMKnepTuM","pastPrice":"_2TqV8qNT9cykzAlTiYQzpR","price":"_3cwJgygKLOPOt2029qoP1N productPrice","tiramisuPrice":"_2wrNPOYclA2VkEjjphjqZ-","notAvailable":"_1auhVO81MuL2pF5rLj2JSv","img-fit-container":"NmGramNcnIM1VmiTq5UPX","img":"_2uBcoliwtdVtvoPWbz7_J-","promotion":"_3mo81yT_Bn4nSPrC-H949r","pricePromotion":"c6uXk5nCCEFUGL2aXVp0b","shine":"_1o_fRI-nt5oPuV0oLoa5zf"};

/***/ })

}]);